import { eur, monthLabel } from "./format";

const slug = (s) => s.replace(/\s+/g, "-").toLowerCase();

const Num = ({ value, count, accent, testId, className = "" }) => (
  <td className={`px-3 py-2.5 text-right whitespace-nowrap ${className}`}>
    <span className={`font-mono font-semibold ${accent}`} data-testid={testId}>{eur(value)}</span>
    {count !== undefined && <span className="ml-1.5 text-xs text-slate-500">({count})</span>}
  </td>
);

const Margin = ({ value, pct, testId, className = "" }) => (
  <td className={`px-3 py-2.5 text-right whitespace-nowrap ${className}`}>
    <span className={`font-mono font-semibold ${value < 0 ? "text-rose-300" : "text-amber-200"}`} data-testid={testId}>{eur(value)}</span>
    <span className={`ml-1.5 text-xs ${pct === null || pct === undefined ? "text-slate-600" : pct < 30 ? "text-rose-400" : "text-slate-400"}`}>{pct === null || pct === undefined ? "—" : `${pct}%`}</span>
  </td>
);

export const RepTable = ({ rows, month }) => {
  const t = rows.reduce((a, r) => ({
    written_count: a.written_count + r.written_count, written_value: a.written_value + r.written_value,
    cost_value: a.cost_value + r.cost_value,
    invoiced_count: a.invoiced_count + r.invoiced_count, invoiced_value: a.invoiced_value + r.invoiced_value,
    open_count: a.open_count + r.open_count, open_value: a.open_value + r.open_value,
    zero_count: a.zero_count + r.zero_count,
  }), { written_count: 0, written_value: 0, cost_value: 0, invoiced_count: 0, invoiced_value: 0, open_count: 0, open_value: 0, zero_count: 0 });
  const tMargin = t.written_value - t.cost_value;
  const tPct = t.written_value > 0 ? Math.round((tMargin / t.written_value) * 1000) / 10 : null;

  return (
    <div className="min-w-0 rounded-2xl bg-slate-900/70 ring-1 ring-white/5" data-testid="rep-table">
      <div className="border-b border-white/5 p-5">
        <p className="text-xs font-bold uppercase tracking-[0.18em] text-slate-400">By rep</p>
        <p className="mt-0.5 text-sm text-slate-500">Written, cost, margin & invoiced are for {monthLabel(month)} · open WIP and zero-value cover all open jobs this year</p>
      </div>
      <div className="overflow-x-auto">
        <table className="w-full text-sm">
          <thead>
            <tr className="text-[11px] font-bold uppercase tracking-[0.14em] text-slate-500">
              <th className="px-5 py-3 text-left">Rep</th>
              <th className="px-3 py-3 text-right">Written</th>
              <th className="px-3 py-3 text-right">Supplier cost</th>
              <th className="px-3 py-3 text-right">Margin</th>
              <th className="px-3 py-3 text-right">Invoiced</th>
              <th className="px-3 py-3 text-right">Open WIP</th>
              <th className="px-5 py-3 text-right">Zero value</th>
            </tr>
          </thead>
          <tbody className="divide-y divide-white/5">
            {rows.length === 0 && <tr><td colSpan={7} className="px-5 py-8 text-center text-slate-500">No rep data yet.</td></tr>}
            {rows.map((r) => (
              <tr key={r.rep} className="hover:bg-white/[0.03]" data-testid={`rep-row-${slug(r.rep)}`}>
                <td className="px-5 py-2.5 font-heading font-black tracking-wide text-slate-100">{r.rep}</td>
                <Num value={r.written_value} count={r.written_count} accent="text-cyan-300" testId={`rep-written-${slug(r.rep)}`} />
                <Num value={r.cost_value} accent="text-rose-300" testId={`rep-cost-${slug(r.rep)}`} />
                <Margin value={r.margin_value} pct={r.margin_pct} testId={`rep-margin-${slug(r.rep)}`} />
                <Num value={r.invoiced_value} count={r.invoiced_count} accent="text-emerald-300" />
                <Num value={r.open_value} count={r.open_count} accent="text-violet-300" />
                <td className="px-5 py-2.5 text-right">
                  {r.zero_count ? (
                    <span className="inline-block rounded-full bg-rose-500/15 px-2.5 py-0.5 font-mono text-sm font-bold text-rose-300 ring-1 ring-rose-500/30" data-testid={`rep-zero-${slug(r.rep)}`}>{r.zero_count}</span>
                  ) : <span className="text-slate-600">—</span>}
                </td>
              </tr>
            ))}
          </tbody>
          {rows.length > 0 && (
            <tfoot>
              <tr className="border-t-2 border-white/15 bg-white/[0.03] text-sm" data-testid="rep-total-row">
                <td className="px-5 py-3 text-[11px] font-bold uppercase tracking-[0.14em] text-slate-300">Total</td>
                <Num value={t.written_value} count={t.written_count} accent="text-cyan-200 text-base" testId="rep-total-written" className="font-bold" />
                <Num value={t.cost_value} accent="text-rose-200 text-base" testId="rep-total-cost" className="font-bold" />
                <Margin value={tMargin} pct={tPct} testId="rep-total-margin" className="font-bold" />
                <Num value={t.invoiced_value} count={t.invoiced_count} accent="text-emerald-200 text-base" testId="rep-total-invoiced" className="font-bold" />
                <Num value={t.open_value} count={t.open_count} accent="text-violet-200 text-base" testId="rep-total-open" className="font-bold" />
                <td className="px-5 py-3 text-right">
                  <span className="font-mono text-base font-bold text-rose-200" data-testid="rep-total-zero">{t.zero_count || "—"}</span>
                </td>
              </tr>
            </tfoot>
          )}
        </table>
      </div>
    </div>
  );
};
